import { ImResponse, resolve, storeHomeNVClient } from 'services/api';

export function getPlatformData(params: { storeId: string; startTime: string; endTime: string }) {
  return resolve(
    storeHomeNVClient.get<
      ImResponse<
        {
          countDt: string;
          data: string;
          dt: string;
        }[]
      >
    >('/api_gateway/dashboard/platform/perf', { params }),
  );
}

export function exportPlatformData(body: {
  platform?: General.PlatformUpperCase;
  departmentIds: number[];
  startTime: string;
  endTime: string;
  storeType?: Dashboard.ReceptionScore.StoreType;
  storeIds: string[];
}) {
  return storeHomeNVClient.post('/api_gateway/dashboard/platform/perf/export', body);
}
